import { useContext, useState } from 'react'

import { AppContext } from 'Const'
import { Customer } from 'Types'
import { isDelivery, isDropOff, isPickup, isShipping, isTable } from 'Utils/cartFulfillment'
import { Inquiry, useInquiry } from 'Utils/inquiry'

enum Titles {
  DELIVERY = 'Delivery',
  DROP_OFF = 'Drop-off',
  PICKUP = 'Pickup',
  SHIPPING = 'Shipping',
  TABLESIDE = 'Tableside',
}

export const useFulfillmentStepTexts = (): [resetButtonText: string, stepTitle: string] => {
  const { cart } = useContext(AppContext)
  const { hasPickupableItems, hasShippingableItems, fulfillment } = cart

  const isSeveralPickupLocations = hasPickupableItems && cart.availablePickupLocations.length > 1
  const resetButtonText =
    isTable(fulfillment) || isDropOff(fulfillment) || !isSeveralPickupLocations ? 'View' : 'Change'

  let stepTitle: string

  if (isDropOff(fulfillment)) {
    stepTitle = Titles.DROP_OFF
  } else if (isDelivery(fulfillment)) {
    stepTitle = Titles.DELIVERY
  } else if (isTable(fulfillment)) {
    stepTitle = Titles.TABLESIDE
  } else if (isShipping(fulfillment)) {
    stepTitle = Titles.SHIPPING
  } else {
    stepTitle = Titles.PICKUP
  }

  if (hasPickupableItems && hasShippingableItems) {
    stepTitle = `${Titles.PICKUP} or ${Titles.SHIPPING}`
  }

  return [resetButtonText, stepTitle]
}

export const useCustomer = (): Customer | null => {
  const { customer } = useContext(AppContext)

  return !customer?.isAnonymous ? customer : null
}

export const useFulfillmentKindAddress = (): string => {
  const {
    cart: { fulfillment },
  } = useContext(AppContext)

  let kindAddress = ''
  const isDeliveryOrShipping = isDelivery(fulfillment) || isShipping(fulfillment)

  if (isDropOff(fulfillment)) {
    const address = fulfillment.dropOffLocation.address
    const { address1, address2, city } = address
    kindAddress = `${address1}${address2 ? ` (${address2})` : ''}, ${city}`
  } else if (isPickup(fulfillment)) {
    const address = fulfillment.location.address
    const { address: address1, city } = address
    kindAddress = `${address1}, ${city}`
  } else if (isDeliveryOrShipping && fulfillment.address) {
    const address = fulfillment.address
    const { address1, address2, city } = address
    kindAddress = `${address1}${address2 ? ` (${address2})` : ''}, ${city}`
  }

  return kindAddress
}
export enum SignUpStates {
  CODE = 'code',
  COMPLETED = 'completed',
  FORM = 'form',
  MULTIPLE = 'multiple',
  PASSWORD = 'password',
  PHONE = 'phone',
}

export const useSignUpState = (
  defaultState = SignUpStates.PHONE,
): [state: Inquiry<SignUpStates>, setState: (state: SignUpStates) => void] => {
  const [__state, setState] = useState<SignUpStates>(defaultState)
  const state = useInquiry(__state)
  return [state, setState]
}
